export const inboundEmailApi = (client) => ({
    /// The org's inbound address ("support+<slug>@bacsys.net") + Postal
    /// config (local-part + domain) for the Settings UI to display.
    getConfig: () => client.get('/api/v1/inbound-email/config')
        .then((r) => r.data),
    /// Sub-address aliases — additional +slug values that route to this org
    /// (e.g. +smscorp pointing at the same workspace as +sila).
    listAliases: () => client.get('/api/v1/inbound-email/aliases')
        .then((r) => r.data.data),
    addAlias: (alias) => client.post('/api/v1/inbound-email/aliases', { alias })
        .then((r) => r.data.data),
    removeAlias: (id) => client.delete(`/api/v1/inbound-email/aliases/${id}`)
        .then((r) => r.data),
    /// Recent inbound deliveries (success + bounced + error) for this org.
    listLog: (limit = 50) => client.get('/api/v1/inbound-email/log', { params: { limit } }).then((r) => r.data.data),
});
//# sourceMappingURL=inbound-email.js.map